import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import dropdownvertical from '../assets/images/drop_vertical.svg';
import MainSidebar from '../components/MainSidebar';
import heart_icon from '../assets/images/heart_icon.svg';
import tip_icon from '../assets/images/tip_icon.svg';
import comment_icon from '../assets/images/comment_icon.svg';
import bookmark_icon from '../assets/images/bookmark_icon.svg';
import bookmark_icon_fill from '../assets/images/bookmark_icon_fill.svg';
import heart_icon_fill from '../assets/images/heart_icon_fill.svg';
import verified from '../assets/images/verified.svg';
import HomeSidebarFooterLinks from '../components/HomeSidebarFooterLinks';
import PostMetaSingle from '../components/PostMetaSingle';
import RecentPosts from '../components/RecentPosts';
import CustomSlider from '../components/CustomSlider';
import SubscribeButton from '../components/SubscribeButton';
import UserMention from '../components/UserMention';
import PostDropdownSingle from '../components/PostDropdownSingle';
import SidebarSearch from '../components/SidebarSearch';
import Subscription from '../components/Subscription';
import config from '../config/config'; 

const SinglePost = () => {

  const { post_id, username } = useParams();
  const [post, setPost] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [reportReason, setReportReason] = useState('');
  const [selectedReportReason, setSelectedReportReason] = useState('');
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const [isAuthUserPost, setIsAuthUserPost] = useState(false);

  const reportReasons = [
    'Violates OnlyFans Terms of Service',
    'Contains copyrighted material (DMCA)',
    'Child Sexual Abuse Material (CSAM)',
    'Report Spam',
    'Report Abuse'
  ];

  // Check if the user is logged in
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
    }
  }, [navigate]);

useEffect(() => {
    const fetchPostDetails = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error('No token found');
                return;
            }

            console.log('Fetching post details:', { post_id, user_name: username });

            const response = await axios.post(
                `${config.baseURL}/get-single-post`,
                { post_id, user_name: username },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            console.log('API response:', response.data); // Log full response

            if (response.data.success) {
                const data = response.data.data || {};
                const post = data.post || {};
                const authorSubscriptionDetails = data.author_subscription_details || {};

                // Check if post and user details are available
                if (post && post.user) {
                    setPost(post);
                    setIsAuthUserPost(data.is_auth_user_post || false); // Default to false if not available

                    // Check if authorSubscriptionDetails is available
                    if (authorSubscriptionDetails) {
                        setUserData({
                            subs_type: authorSubscriptionDetails.subscription_type || '',
                            subscriptions: authorSubscriptionDetails.subscription_id
                                ? [{
                                    subscription_id: authorSubscriptionDetails.subscription_id,
                                    subscription_plan_period: authorSubscriptionDetails.subscription_plan_period || '',
                                    subscription_amount: authorSubscriptionDetails.subscription_amount || 0
                                }]
                                : [],
                            user_name: post.user.user_name || ''
                        });
                    } else {
                        // Handle case where authorSubscriptionDetails is missing
                        setUserData({
                            subs_type: '',
                            subscriptions: [],
                            user_name: post.user.user_name || ''
                        });
                    }
                } else {
                    console.error('Post or user details are missing');
                }
            } else {
                console.error('Failed to fetch post details:', response.data.error);
            }
        } catch (error) {
            console.error('Error fetching post details:', error);
        }
    };

    if (post_id && username) {
        fetchPostDetails();
    } else {
        console.error('post_id or username is missing');
    }
}, [post_id, username]);


  const handleBackClick = () => {
    navigate(-1);
  };

const getInitials = (name) => {
  if (!name) {
    return ''; // Return an empty string if name is not provided
  }
  // Ensure the name is a string and split it into parts to get initials
  const initials = name
    .toString()
    .split(' ')
    .map(n => n[0])
    .join('');
  return initials.toUpperCase();
};


  const openLightbox = (mediaUrls, index) => {
    setImages(mediaUrls);
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  // Copy URL function
  const copyToClipboard = () => {
    const url = `${window.location.origin}/${post_id}/${username}`;
    navigator.clipboard.writeText(url)
      .then(() => {
        setToastMessage('Link copied to clipboard!');
        setToastType('success');
        setTimeout(() => {
          setToastMessage('');
          setToastType('');
        }, 2000); // Auto-hide after 2 seconds
      })
      .catch(err => {
        setToastMessage('Failed to copy link!');
        setToastType('error');
        setTimeout(() => {
          setToastMessage('');
          setToastType('');
        }, 2000); // Auto-hide after 2 seconds
        console.error('Failed to copy link:', err);
      });
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseURL}/report-user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({ report_to: reportReason, reason: selectedReportReason })
      });
      const data = await response.json();
      if (data.success) {
        setToastMessage('User reported successfully!');
        setToastType('success');
        setTimeout(() => setToastMessage(''), 3000);
      } else {
        setToastMessage('Failed to report user');
        setToastType('error');
      }
    } catch (error) {
      setToastMessage('Error reporting user');
      setToastType('error');
    } finally {
      setShowModal(false);
    }
  };

const getContentWithLinks = (content, mentions = []) => {
  if (!Array.isArray(mentions) || mentions.length === 0) return content;

  let updatedContent = content;

  mentions.forEach(mention => {
    if (mention.user && mention.user.user_name) {
      const mentionText = `@${mention.user.user_name}`;
      const mentionLink = `/${mention.user.user_name}`;
      const regex = new RegExp(`(${mentionText})(?![^<]*>)`, 'g');
      updatedContent = updatedContent.replace(regex, `<a href="${mentionLink}">${mentionText}</a>`);
    }
  });

  return updatedContent;
};
 
  const handleCloseModal = () => setShowModal(false);

  return (
    <div>
      <div className="main_patreonpass_wrapper"> 
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content" id="content"> 
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg
                        width={54}
                        height={54}
                        viewBox="0 0 54 54"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032"
                          stroke="#222"
                          strokeWidth={6}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                    <h1>POST</h1>
                  </div>

                  <div className="head_dropdown"> 
                    <ul>
                      <li className="nav-item dropdown">
                        <Link onClick={copyToClipboard}>
                          <svg
                            className="icon_dropdown share_post_icon"
                            width="54"
                            height="54"
                            viewBox="0 0 54 54"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18.9991 36C18.3325 28 22.7974 13.8002 45.9974 15.0002"
                              stroke="#242529"
                              strokeWidth="4.2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M39 5L49 15L39 25"
                              stroke="#242529"
                              strokeWidth="4.66667"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M21.5556 7H16.6667C12.933 7 11.0661 7 9.64006 7.76295C8.38565 8.43407 7.36578 9.50493 6.72662 10.8221C6 12.3194 6 14.2796 6 18.2V37.8C6 41.7204 6 43.6806 6.72662 45.1779C7.36578 46.4951 8.38565 47.5659 9.64006 48.237C11.0661 49 12.933 49 16.6667 49H35.3333C39.067 49 40.9339 49 42.3599 48.237C43.6144 47.5659 44.6342 46.4951 45.2734 45.1779C46 43.6806 46 41.7204 46 37.8V32.6667"
                              stroke="#242529"
                              strokeWidth="5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="home_post_content">
                  <div className="blog_post_box">
                    <div className="blog_post_content">
                      <div className="content_blog_box">
                        <div className="client-info d-flex">
                          <div className="client_info_left">
                            <div className="client-img">
                              <div className="lazy-container">
                                <a
                                  className={`user_pic_area ${post?.online_status === 'online' ? 'user_online_status' : ''}`}
                                  href={`/${post?.user?.user_name}`}
                                >
                                  {post?.user?.user_details?.profile ? (
                                    <img src={post.user.user_details.profile} alt={post.user.name} />
                                  ) : (
                                    <span>{getInitials(post?.user?.name)}</span>
                                  )}
                                </a>
                              </div>
                            </div>
                            <div className="content">
                              <h6 className="name">
                                <a href={`/${post?.user?.user_name}`}>
                                  {post?.user?.name}
                                  <img className="image_margin_left" src={verified} alt="" />
                                </a>
                              </h6>
                              <span className="designation">
                                <a href={`/${post?.user?.user_name}`}>@{post?.user?.user_name}</a>
                              </span>
                            </div>
                          </div>
                          <div className="client_info_right time_with_drop">
                            <span className="post_time">
                              <a href={`/${post?.id}/${post?.user?.user_name}`}>{post?.created_at_human}</a>
                            </span>
                            <PostDropdownSingle
                              postId={post?.id}
                              userName={post?.user?.user_name}
                              userId={post?.user?.id}
                              authUser={post?.is_auth_user_post}
                            />
                          </div>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: getContentWithLinks(post?.content, post?.mentions) }} />

                        {(post?.is_auth_user_post || post?.type !== 'paid' || post?.purchase_status === 'purchased') && post?.media.length > 0 && (
                          <CustomSlider
                            media={post.media.map((mediaItem) => ({
                              url: mediaItem.url,
                              isVideo: /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)$/i.test(mediaItem.url),
                            }))}
                          />
                        )}

                        {post?.type === 'paid' && post?.purchase_status !== 'purchased' && !post?.is_auth_user_post && (
                          <div className="unlock_blog_post">
                            <div className="unlock_icon">
                              <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                {/* SVG Paths */}
                              </svg>
                              <div className="unlock_price">${post?.price}</div>
                            </div>
                            <div className="unlock_subscribe_btn">
                              <div className="media_wrap_paid">
                                <div className="media_count_left">
                                  <div className="media_count">
                                    {/* SVG Icon */}
                                    {post?.total_images}
                                  </div>
                                  <div className="video_count media_count">
                                    {/* SVG Icon */}
                                    {post?.total_videos}
                                  </div>
                                </div>
                                <div className="post_price_right">
                                  ${post?.price}
                                  <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    {/* SVG Paths */}
                                  </svg>
                                </div>
                              </div>
                              <SubscribeButton postId={post?.id} price={post?.price} />
                            </div>
                          </div>
                        )}

                        <div className="mentions_user_list">
                          <UserMention postId={post?.id} />
                        </div>

                        <PostMetaSingle
                          heart_icon={heart_icon}
                          heart_icon_fill={heart_icon_fill}
                          comment_icon={comment_icon}
                          tip_icon={tip_icon}
                          bookmark_icon={bookmark_icon}
                          bookmark_icon_fill={bookmark_icon_fill}
                          likesCount={post?.likes_count}
                          commentsCount={post?.comments_count}
                          postId={post?.id}
                          userHasLiked={post?.userHasLiked}
                          userId={post?.user?.id}
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="right_main_content">
              <SidebarSearch />
              {post && post.user && <RecentPosts userId={post.user.id} />}
              {isAuthUserPost && (
              <div className="subscription_wrapper">
                <div className="subscription_head">SUBSCRIPTION</div>                
                    <Subscription 
                      subsType={userData.subs_type} 
                      subscriptions={userData.subscriptions} 
                      user_name={userData.user_name} 
                    />               
                </div>
               )}
              <HomeSidebarFooterLinks />
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <>
          <div className="modal-overlay-dark" onClick={handleCloseModal}></div>
          <div className="modal restoreAccessModalAccess fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="restoreAccessModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="restoreAccessModalLabel">Report</h5>
                </div>
                <div className="modal-body">
                  <form id="reportUserForm" onSubmit={handleModalSubmit}>
                    <div className="form-group">
                      {reportReasons.map((reason, index) => (
                        <div className="form-check" key={index}>
                          <input 
                            className="form-check-input" 
                            type="radio" 
                            name="reportReason" 
                            id={`reportReason${index}`} 
                            value={reason} 
                            onChange={(e) => setSelectedReportReason(e.target.value)} 
                            required 
                          />
                          <label className="form-check-label" htmlFor={`reportReason${index}`}>
                            {reason}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary cancel_btn" onClick={handleCloseModal}>Cancel</button>
                      <button type="submit" className="btn btn-primary send_btn" disabled={!selectedReportReason}>Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {toastMessage && (
        <div className={`toastmessage ${toastType} show`}>
          {toastMessage}
        </div>
      )}
    </div>
  );
};
export default SinglePost;
